/* eslint-disable @typescript-eslint/unbound-method */
import { createContext, useContext } from "react";
import { SecurityService } from "../../../utils/security";

export class SecurityServiceContextType {
    constructor (public securityService: SecurityService) {}
}

export const SecurityServiceContext = createContext<SecurityServiceContextType | undefined>(undefined);

export const useSecurityServiceContext = (): SecurityServiceContextType => {
    const context = useContext(SecurityServiceContext);
    if (!context) {
        throw new Error("useContext returned an undefined context for the SecurityServiceContext");
    }
    return context;
};